module.exports = __webpack_public_path__ + "dist/media/loading-white.d77ba2c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icons/loading-white.svg
// module id = 380
// module chunks = 0